import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import FormContentManager from "../../components/common/form/FormContentManager";
import TinyMCEeditor from "../../components/const/TinyMCEeditor";
import TableCell from "../../components/common/ui/TableCell";
import { getProgressDetail } from "../../api/const";

export default function Progress_new() {
  const { id: projectId, dns } = useParams();
  const { state } = useLocation();  
  const editorRef = useRef(null);

  // state로 넘어온 템플릿
  const templateHtml = state?.templateContent || "";
  const templateTitle = state?.templateTitle || "";
  const templateType = state?.templateType || "weekly";

  // form 상태
  const [form, setForm] = useState({
    title: templateTitle,
    type: templateType,
    content: templateHtml,
  });

  // TinyMCE에 state 템플릿 강제 반영 (중요!)
  // 수정/로드용
  useEffect(() => {
    if (editorRef.current && form.content !== undefined) {
      editorRef.current.setContent(form.content || "");
    }
  }, [form.content]);

  const navigate = useNavigate();
  
  // 저장 직전 호출
  const getBody = useCallback(() => {
    const html = editorRef.current?.getContent() || "";
    return {
      layout: null,
      values: {
        title: form.title,
        type: form.type,
        meta: {content: html, type: form.type}
      },
    };
  }, [form]);

  //수정모드
  useEffect(() => {
    if (!dns) return;

    const load = async () => {
      try {
        const data = await getProgressDetail(dns);
        const meta = data.meta || {};

        // form 기본값
        setForm((prev) => ({
          ...prev,
          title: data.title || "",
          type: meta.type || "weekly",
          content: meta.content
        }));

      } catch (err) {
        console.error("WorkOrder load failed:", err);
      }
    };

    load();
  }, [dns]);

  return (
    <FormContentManager
      params={{
        project: projectId,
        module: "const",
        doc_type: "progress",
      }}
      getBody={getBody}
      redirectTo={`/project/${projectId}/const/progress/list`}
      docName={form.type === "weekly" ? "주간 보고서" : "월간 보고서"}
      docDescribe="주/월간 보고서를 작성하세요."
    >

      {/* 템플릿 선택 버튼 */}
      <div className="flex justify-start mb-2">
        <button
          type="button"
          className="border rounded px-4 py-1 bg-gray-100 hover:bg-gray-200 text-sm"
          onClick={() => navigate(`/project/${projectId}/const/userTemplate`)}
        >
          템플릿 선택
        </button>
      </div>

      <div className="bg-white">
        {/* 기본 정보 */}
        <table className="w-full border border-black text-sm mb-4">
          <tbody className="divide-y">
            <tr className="divide-x">
              <TableCell
                label="보고서 제목"
                editing
                input={
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={form.title}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, title: e.target.value }))
                    }
                  />
                }
              />
              <TableCell
                label="종류"
                editing
                input={
                  <select
                    className="w-full border rounded px-2 py-1"
                    value={form.type}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, type: e.target.value }))
                    }
                  >
                    <option value="weekly">주간</option>
                    <option value="monthly">월간</option>
                  </select>
                }
              />
            </tr>
          </tbody>
        </table>

        {/* 본문 */}
        <section className="mt-4">
          <div className="w-full border border-black text-sm">

            {/* 제목 셀 */}
            <div className="border-b border-black px-3 py-2 font-semibold bg-gray-100 text-body-bold">
              보고서 내용
            </div>

            {/* TinyMCE 영역 */}
            <div className="px-3 py-3">
              <TinyMCEeditor
                height={600}
                initialValue={templateHtml}
                editorRef={editorRef}
              />
            </div>
          </div>
        </section>

      </div>
    </FormContentManager>
  );
}